import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { CardFoot, CardText } from './BlackCardContainer';
import { Check, Trophy } from '../icons';

import { GameMode } from '../../models/Enums'
import { t } from '../../i18n'
import { Bdi } from '../../i18n/direction'

const GHOST_WIDTHS = [88, 110, 72, 96, 80]

function BlackCardPlayer({
  onModeChange,
  answers,
  questionCard,
  requiredAnswers,
  onNextPlayerClicked,
  onPickWinnerClicked,
  onGetAnswersClicked,
  answeredPlayers,
  totalNumberOfAnswers
}) {
  const [pickedWinner, setPickedWinner] = useState(null)
  const [confirming, setConfirming] = useState(null)

  const acceptWinner = () => {
    onPickWinnerClicked(confirming)
    setPickedWinner(confirming)
    setConfirming(null)
  }

  const handleMoveToNextPlayerClick = () => {
    onModeChange(GameMode.ANSWERER)
    onNextPlayerClicked()
  }

  const answerers = Object.keys(answers)

  if (answerers.length === 0) {
    const ghosts = Math.max(totalNumberOfAnswers - answeredPlayers.length, 0)
    return (
      <>
        <div className="body with-bar" style={{ gap: 28, paddingTop: 24 }}>
          <section className="bc" aria-label={t('game.questionCard')}>
            <CardText question={questionCard} />
            <CardFoot pick={requiredAnswers} />
          </section>

          <section style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <h2 className="h-m">{t('game.whoAnswered')}</h2>
              <span className="count" style={{ fontSize: 15 }}>{t('common.counter', { n: answeredPlayers.length, max: totalNumberOfAnswers })}</span>
            </div>
            {answeredPlayers.length > 0 &&
              <ul className="names" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {answeredPlayers.map(name => <li key={name} className="name"><Check color="#1f7a52" /><span><Bdi>{name}</Bdi></span></li>)}
              </ul>}
            {ghosts > 0 &&
              <div className="names" aria-hidden="true">
                {Array.from({ length: ghosts }, (_, i) => <span key={i} className="name-ghost" style={{ width: GHOST_WIDTHS[i % GHOST_WIDTHS.length] }}></span>)}
              </div>}
          </section>
        </div>

        <div className="bar">
          <button className="btn btn-primary btn-block" onClick={onGetAnswersClicked}>{t('game.answers')}</button>
        </div>
      </>
    )
  }

  return (
    <>
      <div className={`body${pickedWinner ? ' with-bar' : ''}`} style={{ paddingTop: 28 }}>
        <ol className="subs" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {answerers.map((player, i) => {
            const isWinner = player === pickedWinner
            return (
              <li key={player} className={`sub${isWinner ? ' sub-win' : pickedWinner ? ' sub-off' : ''}`} style={{ '--i': i, ...(isWinner ? { margin: '6px 0' } : {}) }}>
                <span className="sub-num">{i + 1}</span>
                {isWinner && <span className="trophy" role="img" aria-label={t('game.winner')}><Trophy /></span>}
                <button className="bc bc-sm" disabled={pickedWinner && !isWinner} aria-pressed={isWinner || undefined}
                  onClick={() => !pickedWinner && setConfirming(player)}>
                  <CardText tag="span" question={questionCard} answers={answers[player]} handTag />
                </button>
              </li>
            )
          })}
        </ol>
      </div>

      {pickedWinner &&
        <div className="bar">
          <button className="btn btn-primary btn-block" onClick={handleMoveToNextPlayerClick}>{t('game.nextPlayer')}</button>
        </div>}

      {confirming && <>
        <div className="scrim"></div>
        <section className="sheet" role="dialog" aria-modal="true" aria-labelledby="q">
          <span className="grab" aria-hidden="true"></span>
          <div className="sub" style={{ marginTop: 8 }}><span className="sub-num">{answerers.indexOf(confirming) + 1}</span>
            <div className="bc bc-sm" style={{ outline: '3px solid #ee5a4a', outlineOffset: 3 }}>
              <CardText tag="span" question={questionCard} answers={answers[confirming]} handTag />
            </div>
          </div>
          <p id="q" className="h-l" style={{ textAlign: 'center' }}>{t('game.confirmPick')}</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12 }}>
            <button className="btn btn-primary" onClick={acceptWinner}>{t('common.yes')}</button>
            <button className="btn" onClick={() => setConfirming(null)}>{t('common.no')}</button>
          </div>
        </section>
      </>}
    </>
  )
}

BlackCardPlayer.propTypes = {
  onModeChange: PropTypes.func.isRequired,
  answers: PropTypes.object.isRequired,
  questionCard: PropTypes.shape({ id: PropTypes.string, texts: PropTypes.array }).isRequired,
  requiredAnswers: PropTypes.number,
  onNextPlayerClicked: PropTypes.func.isRequired,
  onPickWinnerClicked: PropTypes.func.isRequired,
  onGetAnswersClicked: PropTypes.func.isRequired,
  answeredPlayers: PropTypes.arrayOf(PropTypes.string).isRequired,
  totalNumberOfAnswers: PropTypes.number.isRequired,
}

export default BlackCardPlayer
